<template>
  <b-card title="เพิ่มรายการจองคิว">
    <b-row>
      <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">ด่านชายแดน</h5>
          <b-form-select v-model="selectedBorder" :options="options"
            :class="{ 'is-invalid': showError && !selectedBorder }" />
          <div class="invalid-feedback">กรุณาเลือกด่านชายแดน</div>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-card-text class="mt-1 mb-0 font-weight-bold mb-2" v-if="selectedBorder && count_data != 0">
          <template v-if="out_dateDefault">
            <span class="text-primary">
              คิวที่เหลือ:
              <strong>
                / ด่านชายแดน จังหวัด{{ selectedBorder }} / {{ count_data }}
              </strong>
              คิว
            </span>
          </template>

          <template v-else>
            <span class="text-danger">กรุณาเลือกวันที่</span>
          </template>
        </b-card-text>
      </b-col>

      <b-col md="6">
        <br />
        <b-form-group>
          <h5 class="font-weight-bold">วันที่เดินทางออกประเทศไทย</h5>
          <flat-pickr v-model="out_dateDefault" class="form-control"
            :class="{ 'is-invalid': showError && !out_dateDefault }" :config="outDateConfig" />
          <div class="invalid-feedback">วันที่เดินทางออกประเทศไทย</div>
        </b-form-group>
      </b-col>
      <div class="demo-inline-spacing">
        <h5 class="font-weight-bold">เลือกรอบ</h5>
        <!-- Primary -->
        <b-form-radio v-model="selected" name="some-radio9" value="รอบเช้า" class="custom-control-primary">
          รอบเช้า
        </b-form-radio>

        <!-- success -->
        <b-form-radio v-model="selected" name="some-radio9" value="รอบบ่าย" class="custom-control-success">
          รอบบ่าย
        </b-form-radio>
      </div>
      <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">วันที่เข้าประเทศไทย</h5>
          <flat-pickr v-model="in_dateDefault" class="form-control"
            :class="{ 'is-invalid': showError && !in_dateDefault }" :config="{ dateFormat: 'd-m-Y' }" />
          <div class="invalid-feedback">วันที่เข้าประเทศไทย</div>
        </b-form-group>
      </b-col>

      <!-- <b-card-text class="mt-1 mb-0">
      Selected: <strong>{{ selected }}</strong>
    </b-card-text> -->
    </b-row>

    <b-col cols="12">
      <b-button variant="success" type="submit" @click.prevent="validationForm" :disabled="isLoading">
        <template v-if="isLoading">
          <b-spinner small type="grow" class="mr-1" />
          กำลังบันทึก...
        </template>
        <template v-else>
          บันทึกข้อมูล
        </template>
      </b-button>
    </b-col>

    <h4 class="text-primary font-weight-bold mb-2" v-if="items && items.length > 0">
      ข้อมูลแรงานต่างด้าว : {{ items.length }} รายการ
    </h4>

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="items" :fields="fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
        :filter-included-fields="filterOn" @filtered="onFiltered">
      </b-table>
    </b-col>
  </b-card>
</template>

<script>
// ===== Vue & 3rd-party Plugins =====
import Ripple from "vue-ripple-directive";
import axios from "axios";

// ===== Project Modules =====
import store from "@/store/index";
import API from "@/connect/config";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { BSpinner, BButton } from 'bootstrap-vue'

export default {
  components: {
    flatPickr,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      perPage: 100,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        { key: "No.", label: "ลำดับที่" },
        { key: "alcode", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
        { key: "Prefix", label: "คำนำหน้า" },
        { key: "Username", label: "ชื่อ" },
        { key: "Surname", label: "นามสกุล" },
        { key: "Sex", label: "เพศ" },
        { key: "DateofBirth", label: "วันเดือนปีเกิด" },
      ],
      items: [],
      selected: "รอบเช้า", // ✅ "รอบเช้า" ถูกเลือกโดยอัตโนมัติ
      selectedBorder: null, // ✅ ค่า default (ตรงกับ value: null)
      outDateConfig: {
        dateFormat: "d-m-Y",
        onChange: this.handleOutDateChange.bind(this),
      },
      options: [{ value: null, text: "-- เลือกด่านชายแดน --" }],
      formUser: {
        username: "",
        password: "",
        passwordFieldType: "password",
        firstname: "",
        lastname: "",
      },
      in_dateDefault: null, //new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      out_dateDefault: null, // new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      count_data: 0,
      showError: false,
      isLoading: false,

    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    //  console.log(localStorage.getItem("data_addqueue"));
  },
  mounted() {
    this.getDataSelectOption();

    this.outDateConfig.onChange = this.handleOutDateChange;
    this.totalRows = this.items.length;
    this.getData();
  },
  watch: {
    selectedBorder(newVal) {
      if (newVal) {
        this.count_data = 0; // หากเลือกด่านชายแดน ให้รีเซตเป็น 0
      }

    },
  },
  methods: {
    async getData() {
      const dd = await store.getters.getChang;
      //   const dd = await this.$store.dispatch("data_addqueue");
      console.log(dd);
      this.items = dd[0];
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async handleOutDateChange(selectedDates, dateStr) {



      console.log("📅 วันที่ออกถูกเลือก:", dateStr.split("-"));
      console.log("ด่านชายแดน:", this.selectedBorder);
      // ถ้ามีวันที่เลือก ให้ set 500
      //if (selectedDates && selectedDates.length > 0) {
      if (this.selectedBorder == null) {
        console.log("Selected Border:", this.selectedBorder);

        return;
      }

      const [dayExit, monthExit, yearExit] = dateStr.split("-");
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const params = {
          staffId: jwt.userId,
          date: `${yearExit}${monthExit}${dayExit}`,
        };
        console.log("Request Params", params);
        const res = await axios.get(`${API}queueStatus`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        const stationData = res.data.message.stations.find(
          (station) => station.stationName === this.selectedBorder
        );

        this.count_data = stationData.remaining; // รีเซ็ตค่า count_data ก่อนคำนวณใหม่

        console.log("API Response", stationData)
        return res.data.message.data;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }
    },
    async getDataSelectOption() {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      try {
        const res = await axios.get(`${API}config?userId=${jwt.userId}`);
        console.log("✅ success");
        const responseData = res.data.message.data;

        // แปลงข้อมูลให้ตรงกับรูปแบบ dropdown
        const dynamicOptions = responseData.map((item) => ({
          value: item.stationName, // สมมติ field ชื่อ borderName
          text: item.stationName,
        }));

        // รวม option แรก + ตัวเลือกจาก API
        this.options = [{ value: null, text: "-- เลือกด่านชายแดน --" }, ...dynamicOptions];
      } catch (err) {
        if (err.response) {
          console.error("❌ API Error:", err.response.status);
          console.error("Response:", err.response.data);
        } else {
          console.error("❌ Error:", err.message);
        }
      }
    },

    async Postentry(userId, alcode) {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      const [dayExit, monthExit, yearExit] = this.out_dateDefault.split("-");
      const [dayEntry, monthEntry, yearEntry] = this.in_dateDefault.split("-");

      const _data = {
        userId: userId,
        staffId: jwt.userId,
        shift: this.selected,
        alcode: alcode,
        registeredExitDate: `${yearExit}${monthExit}${dayExit}`,
        registeredEntryDate: `${yearEntry}${monthEntry}${dayEntry}`,
        stationName: this.selectedBorder,
      };

      try {
        const res = await axios.post(`${API}entry`, _data);
        console.log("✅ Entry success:", res.data.message);
      } catch (error) {
        console.error("❌ Entry error:", error.response);
      }
    },
    async Postentry_preRegister(userId, alcode) {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));

      const _data = {
        userId: userId,
        staffId: jwt.userId,
        alcode: alcode,

      };

      try {
        const res = await axios.post(`${API}preRegister`, _data);
        console.log("✅ Entry success:", res.data.message);
      } catch (error) {
        console.error("❌ Entry error:", error.response.data.message);
        //console.error("❌ Entry error:", error.response);
      }
    },
    async validationForm() {
      this.isLoading = true;
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));

      try {
        const promises = this.items.map(async (item) => {
          const _data = new FormData();
          _data.append("companyId", jwt.companyId);
          _data.append("username", item.alcode);
          _data.append("password", "Password@1");
          _data.append("role", "user");
          _data.append("prefix", item.Prefix);
          _data.append("firstname", item.firstname);
          _data.append("lastname", item.lastname);
          _data.append("gender", item.Sex);
          _data.append("nationality", item.Nationality);
          _data.append("alcode", item.alcode);

          try {
            const res = await axios.post(`${API}registerUser`, _data);
            const res_userId = res.data.message.userId;
            console.log("✅ Registered:", res_userId);

            if (this.selectedBorder && this.out_dateDefault && this.in_dateDefault) {
              await this.Postentry(res_userId, item.alcode);
            } else {
              await this.Postentry_preRegister(res_userId, item.alcode);
            }
          } catch (error) {
            console.error("❌ Registration error:", error.response);
            // แสดงข้อความผิดพลาดใน Toast
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.response?.data?.message || "เกิดข้อผิดพลาด",
                icon: "EditIcon",
                variant: "danger",
              },
            });
          }
        });

        await Promise.all(promises);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "บันทึกข้อมูลสำเร็จทั้งหมด",
            icon: "CheckIcon",
            variant: "success",
          },
        });
      } catch (e) {
        console.log(e);
        console.error("❌ เกิดข้อผิดพลาดใหญ่", e);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>